/**
 * Initialize carousel for Hero section
 * @param  {HTMLElement} el Hero element
 */
module.exports = function (el) {
  var $el = $(el)

  $el.on('init', function () {
    var $currentSlide = $(el).find('.slick-active')
    $currentSlide.addClass('slide-active')
  }).slick({
    dots: true,
    infinite: true,
    speed: 400,
    autoplay: true,
    autoplaySpeed: 5000,
    prevArrow:
      '<span class="carousel-prev">Previous</span>',
    nextArrow:
      '<span class="carousel-next">Next</span>',
    useCSS: true,
    cssEase: 'ease-out'
  }).on('beforeChange', function () {
    $(el).find('.slide-active').removeClass('slide-active')
  }).on('afterChange', function (slick, currentSlide) {
    var $currentSlide = $(el).find('.slick-active')
    $currentSlide.addClass('slide-active')
  })
}
